import { differenceInCalendarDays, max, min } from 'date-fns'
import { sortedLastIndexBy } from 'lodash'
import { IRoomWithEvents } from '../../../reducers/bookingCalendar/selectors/rooms'
import clamp from '../../clamp'

//Events in room definitely have to be sorted
export default function filterByDateRange<T extends Pick<IRoomWithEvents, 'events'>>({ from, to, size = 1 }: IFilter) {
  return function filterRooms(rooms: T[]): T[] {
    if (undefined === from || undefined === to) {
      return rooms
    }

    const diffInDaysForRange = differenceInCalendarDays(to, from)
    if (diffInDaysForRange === 0 || size > diffInDaysForRange) {
      return rooms
    }

    return rooms.filter(room => {
      // If room has no events then it means it's always
      // has free room.
      if (room.events.length === 0) {
        return true
      }
      const start = sortedLastIndexBy<{ startDate: Date }>(
        room.events,
        { startDate: from },
        re => {
          return +re.startDate
        },
      )

      let iterationDate = from
      let eventIdx = clamp(start - 1, 0)
      while (iterationDate < to) {
        const allowedSize = differenceInCalendarDays(
          room.events[eventIdx] ? min(room.events[eventIdx].startDate, to) : to,
          iterationDate,
        )
        if (allowedSize >= size) {
          return true
        }
        iterationDate = room.events[eventIdx]
          ? max(room.events[eventIdx].finishDate, from)
          : to
        eventIdx++
      }

      return false
    })
  }
}

interface IFilter {
  from?: Date
  to?: Date
  size?: number
}
